import { ToolPanelDef } from '@ag-grid-community/core'
import { FilterGroupsToolPanelComponent } from './filter-groups-tool-panel.component'
import { Observable } from 'rxjs'

export interface FilterGroupsToolPanelParams<T> {
  gridKey: string
  getExternalFilters: () => T
  setExternalFilters: (externalFilters: T) => void
  cacheLoaded: Observable<boolean>
}

const filterGroupsToolPanelId = 'filterGroupsToolPanel'

/**
 * Creates the configuration needed to show the filter groups tool panel for the grid.
 */
export function createFilterGroupsToolPanel<T>(
  params: FilterGroupsToolPanelParams<T>,
): ToolPanelDef {
  return {
    id: filterGroupsToolPanelId,
    labelDefault: 'Filter Groups',
    labelKey: 'filter',
    iconKey: 'filter',
    toolPanelFramework: FilterGroupsToolPanelComponent,
    toolPanelParams: params,
  }
}
